import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { Sparkles, CalendarDays, Trophy, Award, ScrollText } from "lucide-react";

export function RightSidebar() {
  const [featured, setFeatured] = useState(null);
  const [club, setClub] = useState(null);
  const [weekly, setWeekly] = useState([]);
  const [events, setEvents] = useState([]);
  const [story, setStory] = useState(null);

  useEffect(() => {
    api.get("/glossary/featured").then((r) => setFeatured(r.data)).catch(() => {});
    api.get("/reading-lists", { params: { tur: "Aylık Okuma Kulübü" } }).then((r) => setClub(r.data[0] || null)).catch(() => {});
    api.get("/leaderboard/weekly").then((r) => setWeekly(r.data)).catch(() => {});
    api.get("/badge-events").then((r) => setEvents(r.data)).catch(() => {});
    api.get("/wisdom-stories/daily").then((r) => setStory(r.data)).catch(() => {});
  }, []);

  return (
    <aside className="hidden xl:block space-y-4 xl:sticky xl:top-20 xl:self-start xl:max-h-[calc(100vh-6rem)] xl:overflow-y-auto no-scrollbar" data-testid="right-sidebar">
      {featured && (
        <div className="border border-line rounded-xl p-4 bg-surface">
          <p className="text-xs uppercase tracking-wider text-sage font-bold flex items-center gap-1"><Sparkles size={13} /> Günün Kavramı</p>
          <h3 className="font-serif text-xl text-ink mt-2">{featured.kavram}</h3>
          <p className="text-xs text-ink-2 mt-1 leading-relaxed line-clamp-4">{featured.tanim}</p>
          <Link to="/sozluk" className="text-xs text-terra hover:underline mt-2 inline-block">Sözlükte gör →</Link>
        </div>
      )}
      {club && (
        <Link to={`/liste/${club.id}`} className="block border border-line rounded-xl p-4 bg-surface hover:shadow-md transition-shadow">
          <p className="text-xs uppercase tracking-wider text-gold font-bold flex items-center gap-1"><CalendarDays size={13} /> Şimdi Ortak Okunan</p>
          <h3 className="font-serif text-lg text-ink mt-2">{club.liste_adi}</h3>
          <p className="text-xs text-muted-foreground mt-1 line-clamp-2">{club.aciklama}</p>
        </Link>
      )}
      <div className="border border-line rounded-xl p-4 bg-surface">
        <p className="text-xs uppercase tracking-wider text-terra font-bold flex items-center gap-1"><Trophy size={13} /> Haftalık Liderlik</p>
        <div className="mt-2 space-y-1">
          {weekly.length === 0 && <p className="text-xs text-muted-foreground">Bu hafta henüz puan yok.</p>}
          {weekly.map((w, i) => (
            <Link key={w.id} to={`/uye/${w.id}`} className="flex items-center gap-2 py-1 hover:bg-surface-alt rounded px-1">
              <span className={`font-serif text-lg w-5 ${i < 3 ? "text-gold" : "text-muted-foreground"}`}>{i + 1}</span>
              <span className="text-sm text-ink flex-1 truncate">{w.ad_soyad}</span>
              <span className="text-xs text-terra font-medium">{w.haftalik_ap} AP</span>
            </Link>
          ))}
        </div>
        <Link to="/lider-tablosu" className="text-xs text-terra hover:underline mt-2 inline-block">Tüm sıralamayı gör →</Link>
      </div>
      <div className="border border-line rounded-xl p-4 bg-surface" data-testid="badge-feed">
        <p className="text-xs uppercase tracking-wider text-gold font-bold flex items-center gap-1"><Award size={13} /> Son Kazanılan Rozetler</p>
        <div className="mt-2 space-y-1.5">
          {events.length === 0 && <p className="text-xs text-muted-foreground">Henüz rozet kazanımı yok.</p>}
          {events.map((e, i) => (
            <Link key={i} to={`/uye/${e.user_id}`} className="block text-xs text-ink-2 hover:text-terra">
              🎉 <span className="font-medium text-ink">{e.ad_soyad}</span> "{e.rozet}" rozetini kazandı
            </Link>
          ))}
        </div>
      </div>
      {story && (
        <div className="border border-line rounded-xl p-4 bg-ink text-page relative overflow-hidden grain" data-testid="wisdom-box">
          <p className="text-xs uppercase tracking-wider text-gold font-bold flex items-center gap-1"><ScrollText size={13} /> Günün Bilgelik Hikayesi</p>
          <h3 className="font-serif text-lg text-page mt-2">{story.baslik}</h3>
          <p className="text-xs text-page/70 mt-1 leading-relaxed line-clamp-4">{story.ozet}…</p>
          <Link to={`/hikaye/${story.slug}`} data-testid="wisdom-more" className="text-xs text-gold hover:underline mt-2 inline-block">Devamı →</Link>
        </div>
      )}
    </aside>
  );
}
